import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { SearchField } from 'console/shared/components/fields/search';
import { useCallback, useContext, useState } from 'react';
import { Z3KSettingsEditor } from '../../provider/types';
import { searchInZ3kConfig } from '../view-config/utils';
import { parseConfigWithRouter } from './parseConfig';
import { SearchComponentItem } from './searchComponent';
export function SearchPage() {
    const { config } = useContext(Z3KSettingsEditor);
    const [temp_config, setTempConfig] = useState(config);
    const [search_value, setSearchValue] = useState('');
    const onSearch = useCallback((value) => {
        const mini_search_value = value.toLowerCase().trim();
        setSearchValue(value);
        if (temp_config == null) {
            return;
        }
        const found = searchInZ3kConfig(config, mini_search_value);
        setTempConfig(Object.fromEntries(found.sort()));
    }, [setSearchValue, temp_config, config, setTempConfig]);
    const onClearSearch = useCallback(() => {
        setSearchValue('');
        setTempConfig(config);
    }, [setSearchValue, setTempConfig, config]);
    return config == null ? null : (_jsxs(Box, { display: "flex", flexDirection: "column", gap: 1, px: 2, pt: 2, children: [_jsx(SearchField, { autoFocus: true, value: search_value, onChange: onSearch, onClear: onClearSearch, placeholder: "\u041F\u043E\u0438\u0441\u043A \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432...", size: "small", sx: {
                    padding: 1,
                    borderRadius: 30,
                } }), temp_config != null && (_jsx(Box, { gap: 2, children: Object.entries(parseConfigWithRouter(temp_config))
                    .sort()
                    .map(([key, value]) => (_jsx(SearchComponentItem, { group_name: key, value: value }, key))) }))] }));
}
SearchPage.isError = () => false;
SearchPage.isShown = (is_service_view, config, spec, is_staff, is_climatic) => !is_climatic;
